<template>
  <div class="configuration-widget text">
    {{definition.label}}
    <MetabaseCard v-if="definition.type == 'MetabaseWidget'" :definition="definition"/>
  </div>
</template>

<script>
  import MetabaseCard from './ConfigCards/MetabaseCard.vue';
  export default {
    components: {
      MetabaseCard
    },
    props: {
      definition: {
        type: Object
      }
    }
  }
</script>

<style scoped>
  .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
  }
</style>